import React from 'react';

interface ToggleProps {
    options: Array<{ label: string; value: string; icon?: React.ReactNode }>;
    value: string;
    onChange: (value: string) => void;
    className?: string;
    disabled?: boolean;
}

const Toggle: React.FC<ToggleProps> = ({ options, value, onChange, className = '', disabled = false }) => {
    const isActive = value === options[0].value;
    return (
        <button
            type="button"
            onClick={() => { if (!disabled) onChange(isActive ? options[1].value : options[0].value); }}
            disabled={disabled}
            className={`relative w-12 h-8 flex items-center rounded-full transition-colors duration-200 border border-gray-300 focus:outline-none ${isActive ? 'bg-primary' : 'bg-gray-300'} ${disabled ? 'opacity-60 cursor-not-allowed' : ''} ${className}`}
        >
            <span
                className={`absolute left-1 top-1 w-5 h-5 rounded-full bg-white shadow transition-transform duration-200 ${isActive ? 'translate-x-4' : ''}`}
            />
        </button>
    );
};

export default Toggle;
